exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.cellLinkType[data-v-8bc3a4f2] {\n    text-align: center;\n}\n", ""]);

// exports
